import React from 'react'
import { Link } from '@common/material'
import { localizedStrings } from '@core/strings'
import { Flex, Text } from '@fundamentals'
import { User } from '@core/entities/user'
import { TimelineBlockBase } from '@common/Timeline'
import { CopyToClipboardButton } from '@common/CopyToClipboardButton'
import { UserProfileHoverWrapper } from '@elements/UserProfileHoverWrapper'

type ComponentProps = {
  user: User
  onEdit?: () => void
}

export const TimelineUserBlock: React.FC<ComponentProps> = ({
  user,
  onEdit,
}) => {
  if (!user) return null
  return (
    <TimelineBlockBase title={localizedStrings.user}>
      <UserProfileHoverWrapper userId={user.id}>
        {onEdit ? (
          <Link
            href=''
            onClick={(e) => {
              e.preventDefault()
              onEdit()
            }}
          >
            {user.getFullName()}
          </Link>
        ) : (
          <Text variant='body2'>{user.getFullName()}</Text>
        )}
      </UserProfileHoverWrapper>
      {user.company && <Text fontSize={12}>{user.company}</Text>}
      {user.email && (
        <Flex
          alignItems='center'
          gap={0.5}
          sx={{ '&:hover .copy-clipboard-btn': { opacity: 0.6 } }}
        >
          <Text fontSize={12}>{user.email}</Text>
          <CopyToClipboardButton value={user.email} />
        </Flex>
      )}
    </TimelineBlockBase>
  )
}
